export enum WidgetSenderIdentityType {
  ANONYMOUS = 'ANONYMOUS',
  AGENT = 'AGENT',
  BUSINESS = 'BUSINESS',
}
